import { __decorate, __metadata } from 'tslib';
import { Metadata } from './metadata.js';
import { Type } from '../interfaces/type.js';
import { isCollection } from '../utils/is-utils.js';
import { getClass, nameOf } from '../utils/object-utils.js';
import { NotEnumerable } from '../decorators/base.js';

/**
 * EntityDescription 保存所有装饰器所收集的信息（包括类、属性名、参数位置）
 * @public
 */
class EntityDescription {
    constructor(rawTarget, rawPropertyKey, index) {
        this.rawTarget = rawTarget;
        this.rawPropertyKey = rawPropertyKey;
        if (typeof index === 'number') {
            this.paramIndex = index;
        }
        this.target = rawTarget;
    }
    /**
     * 返回参数在函数中的位置
     */
    get index() {
        return this.paramIndex;
    }
    /**
     * 实体所对应的类
     */
    get target() {
        return getClass(this.rawTarget);
    }
    set target(target) {
        this.setTarget(target);
    }
    /**
     * 实体类的名称
     */
    get targetName() {
        return nameOf(this.target);
    }
    /**
     * 被装饰的方法名或属性名
     */
    get propertyKey() {
        return this.rawPropertyKey;
    }
    get typeName() {
        return nameOf(this.rawType);
    }
    get type() {
        return this.rawType;
    }
    set type(type) {
        this.rawType = type;
    }
    get collectionName() {
        return this.collectionType ? nameOf(this.collectionType) : '';
    }
    setTarget(target) {
        this.rawTarget = target;
        let type;
        if (typeof this.paramIndex === 'number') {
            type = Metadata.getParamTypes(this.rawTarget, this.rawPropertyKey)[this.paramIndex];
        }
        else {
            type = Metadata.getType(this.rawTarget, this.rawPropertyKey);
        }
        if (isCollection(type)) {
            this.collectionType = type;
            this.rawType = Object;
        }
        else {
            this.rawType = type;
        }
        this.name = nameOf(this.rawPropertyKey);
    }
}
__decorate([
    NotEnumerable(),
    __metadata("design:type", Type)
], EntityDescription.prototype, "collectionType", void 0);
__decorate([
    NotEnumerable(),
    __metadata("design:type", String)
], EntityDescription.prototype, "name", void 0);
__decorate([
    NotEnumerable(),
    __metadata("design:type", Type)
], EntityDescription.prototype, "rawType", void 0);
__decorate([
    NotEnumerable(),
    __metadata("design:type", Number)
], EntityDescription.prototype, "paramIndex", void 0);

export { EntityDescription };
//# sourceMappingURL=entity-description.js.map
